import { render, staticRenderFns } from "./VtFlags.vue?vue&type=template&id=603de192&"
import script from "./VtFlags.vue?vue&type=script&lang=js&"
export * from "./VtFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports